module.exports = __webpack_public_path__ + "img/koincapital.54af319.png";